import { adapter } from './cobrowsing.model';

export const CobrowsingSelector = {
  ...adapter.getSelectors(),
};
